import { Platform, StyleSheet, View } from 'react-native'
import { Pot } from '@ppwr/poker'
import { TutorialBoard } from '../Board'
import { PlayerColumn, PlayerColumnProps } from './PlayerColumn'
import { observer } from 'mobx-react-lite'
import { getPlayersForColumn, sortPlayerStartingByMe } from './utils'
import { useStore } from '../../../models'
import { useResponsive } from '@/screens/new-design/hooks'
import { useLayoutShiftRegistry } from '@/hooks/useLayoutShiftRegistry'

interface TutorialTableProps extends Omit<PlayerColumnProps, 'players'> {
  onSidePotsPress: (pots: Pot[]) => void
}

const isWeb = Platform.OS === 'web'

export const TutorialTable = observer(({ onSidePotsPress, onPlayerCellPress }: TutorialTableProps) => {
  const {
    game: { myPlayer, seatedPlayers },
    session: { isTeacher }
  } = useStore()
  const sortedPlayers = sortPlayerStartingByMe(seatedPlayers, myPlayer)
  // const { verticalScale } = useResponsive()
  const { register } = useLayoutShiftRegistry()

  // const cardsHeight = verticalScale(24) * 3

  return (
    <>
      <View
        style={[
          styles.container,
          {
            paddingBottom: 130 //cardsHeight
          }
        ]}
      >
        <View style={[styles.column, isWeb ? webStyles.playersContainer : {}, { paddingRight: 5 }]}>
          <PlayerColumn
            players={getPlayersForColumn(sortedPlayers, true)}
            onPlayerCellPress={onPlayerCellPress}
            isTeacher={isTeacher}
          />
        </View>
        <View
          style={[styles.board, isWeb ? webStyles.board : {}]}
          onLayout={(e) => register('myFirstGame.board', e)}
          id="myFirstGame.board"
        >
          <TutorialBoard />
        </View>
        <View style={[styles.column, isWeb ? webStyles.playersContainer : {}, { paddingLeft: 5 }]}>
          <PlayerColumn
            right
            players={getPlayersForColumn(sortedPlayers)}
            onPlayerCellPress={onPlayerCellPress}
            isTeacher={isTeacher}
          />
        </View>
      </View>
    </>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 10
    //paddingBottom: 48,
  },
  board: {
    flex: 1,
    borderRadius: 100,
    alignItems: 'center',
    height: '100%'
  },
  column: {
    flex: 0.6,
    zIndex: 1,
    height: '100%'
  }
})
const webStyles = StyleSheet.create({
  board: {
    height: '100%',
    width: '100%',
    flexGrow: 1,
    minWidth: 160,
    marginHorizontal: 10
  },
  playersContainer: {
    flexGrow: 2
  }
})
